import React from "react";
import { Box, Typography, Grid, Button as MaterialButton } from "@mui/material";
import { Element, useEditor } from "@craftjs/core";
import { Container } from "./user/Container";
import { Button } from "./user/Button";
import { Text } from "./user/Text";
import { Image } from "./user/Image";
import { RichText } from "./user/RichText";
import { Carousel } from "./user/Carousel";
import { Input } from "./user/Input";
import { TextArea } from "./user/TextArea_";
import { ImageInput } from "./user/ImageInput";
import { CardCraft } from "./user/CardCraft";
import { Layout } from './user/Layout';
import { BulmaElement } from "./user/BulmaElement";
import { RadioGroupComponent } from "./user/RadioGroupComponent";
import { CheckboxGroupComponent } from "./user/CheckboxGroupComponent";
import { ImageGrid } from "./user/ImageGrid";
import { ListCraft } from "./user/ListCraft";
import { StackCraft } from "./user/StackCraft";
import { Select } from "./user/Select";
import { Switch } from "./user/Switch";
import { Table } from "./user/Table";
import { Aggregator } from "./user/Aggregator";
import { Link } from "./user/Link";
import { IconButton } from "./user/IconButton";
import { TabControl } from "./user/TabControl";
import { NavbarControl } from "./user/NavbarControl";
import { TabContainer } from "./user/TabContainer";
import { Content } from "./user/Content";
import { CopyButton } from "./user/CopyButton";
import { MarkdownDisplay } from "./user/MarkdownDisplay";
import { Shop } from "./user/Shop";
import { Requests, RequestDeleteButton, RequestDeleteCross, RequestItemWrapper } from "./user/Requests";
import { RequestButton } from "./user/RequestButton";
import { Website } from "./user/Website";
import { Cart } from "./user/Cart";

export const Toolbox = () => {
  const { connectors } = useEditor();

  return (
    <Box px={2} py={2}>
      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1}>

        <Typography>Drag to add</Typography>

        <Grid container spacing={1} sx={{ flexWrap: 'wrap' }}>

        <MaterialButton
            ref={ref => connectors.create(ref, <Aggregator size="small">Click me</Aggregator>)}
            variant="contained"
          >
            Aggregator
          </MaterialButton>
           <MaterialButton
            ref={ref => connectors.create(ref, <CopyButton/>)}
          >
            Copy Value Button
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <Button size="small">Click me</Button>)}
            variant="contained"
          >
            Button
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <IconButton size="small">Click me</IconButton>)}
            variant="contained"
          >
             Icon Button
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Text text="Hi world" />)}
            variant="contained"
          >
            Text
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <Content />)}
            variant="contained"
          >
            Html Content
          </MaterialButton>

          {/*<MaterialButton
            ref={ref => connectors.create(ref, <Element is={Container} padding={20} width='100%' canvas />)}
            variant="contained"
          >
            Container
          </MaterialButton>*/}

          <MaterialButton
            ref={ref => connectors.create(ref, <Layout padding={0} width='100%' canvas={true} />)}
            variant="contained"
          >
            Layout
          </MaterialButton>
          

          <MaterialButton
            ref={ref => connectors.create(ref, <Input />)}
            variant="contained"
          >
            Input
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <Link />)}
            variant="contained"
          >
            Link or com
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <TextArea />)}
            variant="contained"
          >
            Text Area
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <NavbarControl />)}
            variant="contained"
          >
            Nav Bar
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <TabControl />)}
            variant="contained"
          >
            Tab Control
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <TabContainer />)}
            variant="contained"
          >
            Tab Container
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RadioGroupComponent />)}
            variant="contained"
          >
            Radio Group
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <CheckboxGroupComponent />)}
            variant="contained"
          >
            Check Group
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Image />)}
            variant="contained"
          >
            Image Display
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <ImageInput />)}
            variant="contained"
          >
            Image Input
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RichText />)}
            variant="contained"
          >
            RichText
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <MarkdownDisplay />)}
            variant="contained"
          >
            Markdown
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Carousel />)}
            variant="contained"
          >
            Carousel
          </MaterialButton>

          {/*<MaterialButton
            ref={ref => connectors.create(ref, <BulmaElement />)}
            variant="contained"
          >
            Bulma Element
          </MaterialButton>*/}

          <MaterialButton
            ref={ref => connectors.create(ref, <CardCraft />)}
            variant="contained"
          >
            Card
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <ImageGrid />)}
            variant="contained"
          >
            Image Grid
          </MaterialButton>

          {/*<MaterialButton
            ref={ref => connectors.create(ref, <ListCraft />)}
            variant="contained"
          >
            Stack (Old)
          </MaterialButton>*/}

          {/* NEW: StackCraft component */}
          <MaterialButton
            ref={ref => connectors.create(ref, <StackCraft />)}
            variant="contained"
          >
            Stack
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Shop />)}
            variant="contained"
          >
            Shop
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Requests />)}
            variant="contained"
          >
            Requests
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RequestButton />)}
            variant="contained"
          >
            Request Button
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RequestDeleteButton />)}
            variant="contained"
          >
            Request Delete Button
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RequestDeleteCross />)}
            variant="contained"
          >
            Request Delete Cross
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <RequestItemWrapper />)}
            variant="contained"
          >
            Request Item Wrapper
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Cart />)}
            variant="contained"
          >
            Cart
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Website />)}
            variant="contained"
          >
            Website
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Select />)}
            variant="contained"
          >
            Select
          </MaterialButton>

          <MaterialButton
            ref={ref => connectors.create(ref, <Switch />)}
            variant="contained"
          >
            Switch
          </MaterialButton>
          <MaterialButton
            ref={ref => connectors.create(ref, <Table />)}
            variant="contained"
          >
            Table
          </MaterialButton>

        </Grid>
      </Grid>
    </Box>
  );
};